export const itemsExplora = [];

export const itemsMenuEstatic = {
    item: [
        {
            text: 'Portada',
            href: '/3catinfo/',
            slug: 'home'
        },
        {
            type: 'web_actualitat_seccio',
            text: 'Últimes notícies',
            id: 'ultimes-noticies',
            slug: 'ultimes-noticies'
        },
        {
            type: 'web_actualitat_seccio',
            text: 'En 3 minuts',
            id: '3-minuts',
            slug: '3-minuts'
        },
        {
            type: 'web_actualitat_seccio',
            text: 'El meu 3CatInfo',
            id: 'meu3catinfo',
            slug: 'meu3catinfo'
        },
        {
            type: 'web_actualitat_seccio',
            text: 'Explora',
            id: 'temes',
            slug: '#',
            opcions: {}
        },
        {
            text: 'Esports',
            href: 'https://www.3cat.cat/esport3/'
        },
        {
            type: 'web_actualitat_seccio',
            text: 'El Temps',
            id: 'el-temps',
            slug: 'el-temps'
        },
        {
            type: 'web_actualitat_seccio',
            text: 'Directes',
            id: 'directes',
            icona: 'directes',
            icona_alt: 'Directes',
            opcions: {}
        }
    ]
};

export const itemsMenuAmp = {
    item: [
        {
            type: 'web_actualitat_seccio',
            text: 'Directes',
            id: 'directes',
            icona: 'directes',
            icona_alt: 'Directes',
            slug: 'directes'
        },
        {
            type: 'web_actualitat_seccio',
            text: 'Últimes notícies',
            id: 'ultimes-noticies',
            slug: 'ultimes-noticies'
        },
        {
            type: 'web_actualitat_seccio',
            text: 'El temps',
            id: 'el-temps',
            slug: 'el-temps'
        },
        {
            type: 'web_actualitat_seccio',
            text: 'Esports',
            id: 'esprots',
            slug: 'esprots'
        },
        {
            type: 'web_actualitat_seccio',
            text: 'Societat',
            id: 'societat',
            slug: 'societat'
        },
        {
            type: 'web_actualitat_seccio',
            text: 'Política',
            id: 'politica',
            slug: 'politica'
        },
        {
            type: 'web_actualitat_seccio',
            text: 'Món',
            id: 'mon',
            slug: 'mon'
        },
        {
            type: 'web_actualitat_seccio',
            text: 'Cultura',
            id: 'cultura',
            slug: 'cultura'
        },
        {
            type: 'web_actualitat_seccio',
            text: 'Anàlisi',
            id: 'analisi',
            slug: 'analisi'
        },
        {
            type: 'web_actualitat_seccio',
            text: 'Comarques',
            id: 'comarques',
            slug: 'comarques'
        },
        {
            type: 'web_actualitat_seccio',
            text: 'Eleccions',
            id: 'eleccions',
            slug: 'eleccions'
        }
    ]
};
